import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AppRoles, PermissionKeys} from '../app.constants';

@Component({
    selector: 'app-transactions',
    templateUrl: './transactions.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TransactionsComponent {

    AppRoles = AppRoles;
    PermissionKeys = PermissionKeys;

    constructor() {
    }

}
